import { useI18n } from "@wojo/localization";
import { useLightMe } from "./use-light-me";

export const useNavProfile = () => {
    const { customer } = useLightMe();

    const i18n = useI18n("account");
    const firstName = customer?.firstName || "";
    const firstInitial = firstName.charAt(0) || "";
    const lastName = customer?.lastName || "";
    const lastInitial = lastName.charAt(0) || "";
    const profileImage = customer?.profileImageAsset?.location || "";

    return {
        accountDisplayText: i18n.account.navigation.greeting.l({
            accountDisplayName: `${firstName} ${lastInitial}`,
            accountFirstName: firstName || "",
        }),
        accountInitials: `${firstInitial}${lastInitial}`,
        accountAvatar: profileImage,
    };
};
